'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/millisecondsAgo.js
// module id = 700
// module chunks = 0